import { ValuationReportPointerParameterValue } from '~/scenes/Automation/Flows/Actions/Base/types.flow';

import { PARAMETER_VALUE_TYPE } from '../../constants';

export default (): ValuationReportPointerParameterValue => ({
  type: PARAMETER_VALUE_TYPE.EVENT_VALUATIONREPORT_POINTER,
  variable: null,
});
